import { Component, Input, OnInit } from '@angular/core';
import { PatientDocumentService } from '../../patient-documents-list/patient-document-list.service';
import { AuthService } from 'src/app/services/auth.service';
import { PhrasesService } from '../../phrases/phrases.service';
import { CKEditorService } from '../../note-editor/ckeditor.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmationComponent } from '../../census-patient-list/dialog-confirmation/dialog-confirmation.component';

@Component({
  selector: 'app-tagged-text',
  templateUrl: './tagged-text.component.html',
  styleUrls: ['./tagged-text.component.css']
})
export class TaggedTextComponent implements OnInit {
  
  @Input() patient: any;
  currentUser : any;
  documents: any;
  dataSource: any = [];
  displayedColumns = ['text','operation'];
  private toastrTimerId: any = null;

  constructor(
    private patientDocumentService: PatientDocumentService,
    private authService: AuthService,
    private phrasesService: PhrasesService,
    private ckeditorService: CKEditorService,
    private toastr: ToastrService,
    private dialog: MatDialog,

  ) {
    this.currentUser = this.authService.currentUser;
  }

  async ngOnInit() {
    this.getTaggedText();
  }
  
  getTaggedText() {
    this.patientDocumentService.getTaggedText(this.patient._id, this.currentUser.company_id).subscribe((res: any) => {
      if (res.status == 200) {
        this.documents = res.data;
        this.dataSource = this.documents;
      }
    });
  }

  deleteText(document_id, text) {
    let dialogRef = this.dialog.open(DialogConfirmationComponent, {
      data: {
        message: 'Are you sure you want to delete?'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === "true") {
        this.patientDocumentService.removeTaggedText(document_id, text).subscribe((res:any)=>{
          if(res.status == 200) {
            this.toastr.success('Removed Successfully', 'Success');
            this.getTaggedText();
          }
        });
      } else return;
    })
  }
  createHeadingToInsert( text ) {
    let textToInsert = `<span>${ text }</span> `;
    return textToInsert;
  }

  useTextInNoteEditor( text ) {
    clearTimeout( this.toastrTimerId );
    console.log('text',text);
    
    const editorInstance = this.ckeditorService.getEditorInstance();
    console.log('editorInstance',editorInstance);
    
    if ( this.phrasesService.doesHeadingExistsInEditor( editorInstance, text ) === true ) {
      this.toastrTimerId = setTimeout(() => {
        this.toastr.error( 'This text is already present. Please try some other!', 'Failed' );
      }, 300 );

      return;
    }

    if ( this.ckeditorService.isCursorOnEmptyLine() === true ) {
      const pElem = this.ckeditorService.getCursorRootParent();
      if ( pElem?.getName() === 'p' ) {
        pElem.setHtml( '' );
      }
    } else if (
      this.ckeditorService.isCursorAtStartOfLine() === true &&
      this.ckeditorService.getCursorDirectParent()?.getName() !== 'strong'
    ) {
      // do nothing...
    } else {
      if ( this.phrasesService.doesEditorContainLastSectionSeparator( editorInstance.getData())) {
        this.ckeditorService.pushLastSectionForwards( this.phrasesService.lastSectionSeparator );
      } else {
        this.ckeditorService.moveNextForNewHeading();
      }
    }

    editorInstance.insertHtml( this.createHeadingToInsert( text ));
  }

}
